import { BrowserRouter, Route, Routes } from "react-router-dom";
import FetchSharedData from "./layouts/FetchSharedData";
import NotFound404 from "./layouts/NotFound404";
import ProtectedAuthRoutes from "./layouts/ProtectedAuthRoutes";
import ProtectedUnreadMessages from "./layouts/ProtectedUnreadMessages";
import ContentComplain from "./modules/pages/complain/content/content";
import Termination from "./modules/pages/myAccount/account/Termination";
import AgentInsurance from "./modules/pages/myAccount/account/components/agentInsurance";
import DiscountCodePage from "./modules/pages/myAccount/account/discountCode";
import IncreaseCredit from "./modules/pages/myAccount/account/increaseCredit";
import MessagesTablePage from "./modules/pages/myAccount/account/messagesTableList";
import NewTicket from "./modules/pages/myAccount/account/newTicket";
import Terminate from "./modules/pages/myAccount/print/Terminate";
import OrderShipment from "./modules/pages/newLetter/OrderShipment";
import NewExternalAgent from "./modules/pages/newLetter/newExAgent";
import Bulk from "./modules/pages/newLetterBulk/Bulk";
import About from "./pages/About";
import AgentPage from "./pages/AgentPage";
import Application from "./pages/Application";
import BeforRentPage from "./pages/BeforRentPage";
import BulkOrderPage from "./pages/BulkOrderPage";
import CallOrderPage from "./pages/CallOrderPage";
import Contact from "./pages/Contact";
import ContentBox from "./pages/ContentBox";
import DootToDoorPage from "./pages/DootToDoorPage";
import ExpressPostPage from "./pages/ExpressPostPage";
import ExternalPage from "./pages/ExternalPage";
import Guide from "./pages/Guide";
import Information from "./pages/Information";
import InternalPage from "./pages/InternalPage";
import MyShipments from "./pages/MyShipments";
import OnlinePaymentPage from "./pages/OnlinePaymentPage";
import PayInPlacePage from "./pages/PayInPlacePage";
import PeykPage from "./pages/PeykPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Rules from "./pages/Rules";
import ShopPage from "./pages/ShopPage";
import Support from "./pages/Support";
import TrackingPage from "./pages/TrackingPage";
import WalletPage from "./pages/WalletPage";
import Account from "./pages/account/Account";
import MyAddresses from "./pages/account/components/address/MyAddresses";
import CodFlowList from "./pages/account/components/cod/CodFlowList";
import DamageRequest from "./pages/account/components/damage/DamageRequest";
import Info from "./pages/account/components/info/Info";
import WalletRequest from "./pages/account/components/wallet/WalletRequest";
import Login from "./pages/auth/login/login";
import AgentRegister from "./pages/auth/register/components/AgentRegister";
import NormalUserRegister from "./pages/auth/register/components/NormalUserRegister";
import Register from "./pages/auth/register/register";
import CityInquiryPage from "./pages/city/CityInquiryPage";
import DevelopersItemPage from "./pages/developers/DevelopersItemPage";
import DevelopersPage from "./pages/developers/DevelopersPage";
import Home from "./pages/home/home";
import MessagePage from "./pages/message/MessagePage";
import MyExternalLetters from "./pages/myLetters/MyExternalLetters";
import PayPage from "./pages/pay/PayPage";
import SuccessPage from "./pages/pay/SuccessPage";
import ActiveAgentList from "./pages/post/agent/ActiveAgentList";
import AgentRequestF from "./pages/post/agent/formAgentFunc";
import AvaBox from "./pages/post/peyk/avaBox/AvaBox";
import Logout from "./pages/public/auth/logout";
import FAQ from "./pages/public/faq/FAQ";
import ExternalPostFactor from "./pages/public/payResult/ExternalPostFactor";
import Failed from "./pages/public/payResult/failed";
import PreFactor from "./pages/public/payResult/preFactor/PreFactor";
import Successful from "./pages/public/payResult/successful";
import Successsed from "./pages/public/payResult/successfulpay";
import Shop from "./pages/shop/Shop";
import Vip from "./pages/vip/Vip";
import WebServicePage from "./pages/webService/WebServicePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<FetchSharedData />}>
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/info" element={<Information />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/guide" element={<Guide />} />

          <Route path="/support" element={<Support />} />

          <Route path="/faq" element={<FAQ />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/complain" element={<ContentComplain />} />
          <Route path="/myletters" element={<MyShipments />} />
          <Route path="/my-external-letters" element={<MyExternalLetters />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />}>
            <Route path="user" element={<NormalUserRegister />} />
            <Route path="agent" element={<AgentRegister />} />
          </Route>

          <Route element={<ProtectedAuthRoutes />}>
            <Route path="/account" element={<Account />}>
              <Route path="" element={<Info />} />
              <Route path="increase-credit" element={<IncreaseCredit />} />
              <Route path="address" element={<MyAddresses />} />
              <Route path="damage" element={<DamageRequest />} />
              <Route path="wallet-request" element={<WalletRequest />} />
              <Route path="insurance" element={<AgentInsurance />} />
              <Route path="cod-flow" element={<CodFlowList />} />
              <Route path="tickets" element={<MessagesTablePage />} />
              <Route path="discount" element={<DiscountCodePage />} />
              <Route path="support" element={<NewTicket />} />

              <Route path="termination" element={<Termination />} />
            </Route>

            <Route element={<ProtectedUnreadMessages />}>
              <Route path="/avabox" element={<AvaBox />} />
              <Route
                path="/new/letter"
                element={<OrderShipment key="letter" />}
              />
              <Route path="/new/cod" element={<OrderShipment key="cod" />} />
              <Route path="/newex" element={<NewExternalAgent />} />
              <Route path="/new/bulk" element={<Bulk />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/vip" element={<Vip />} />
            </Route>

            <Route path="/prewallet" element={<WalletPage />} />
            <Route path="/formagent" element={<AgentRequestF />} />
            <Route path="/messages" element={<MessagePage />} />
          </Route>

          <Route path="/preinternal" element={<InternalPage />} />
          <Route path="/preexternal" element={<ExternalPage />} />
          <Route path="/prepeyk" element={<PeykPage />} />

          <Route path="/preapplication" element={<Application />} />
          <Route path="/preagent" element={<AgentPage />} />
          <Route path="/preshop" element={<ShopPage />} />
          <Route path="/prebox" element={<ContentBox />} />
          <Route path="/payinplace" element={<PayInPlacePage />} />
          <Route path="/expresspost" element={<ExpressPostPage />} />
          <Route path="/doortodoor" element={<DootToDoorPage />} />
          <Route path="/onlinePayment" element={<OnlinePaymentPage />} />
          <Route path="/beforRent" element={<BeforRentPage />} />
          <Route path="/bulkOrder" element={<BulkOrderPage />} />
          <Route path="/callOrder" element={<CallOrderPage />} />
          <Route path="/agent-list" element={<ActiveAgentList />} />
          <Route path="/failed" element={<Failed />} />
          <Route path="/success" element={<Successsed />} />
          <Route path="/external-post/success" element={<SuccessPage />} />
          <Route path="/successful/:id" element={<Successful />} />
          <Route path="/prefactor/:id" element={<PreFactor />} />
          <Route path="/factor/:id" element={<ExternalPostFactor />} />
          <Route path="/tracking/" element={<TrackingPage />} />

          <Route path="pay" element={<PayPage />} />
          <Route path="city-inquiry" element={<CityInquiryPage />} />
          <Route path="/logout" element={<Logout />} />

          <Route exact path="/" element={<Home />} />

          <Route path="print-terminate" element={<Terminate />} />

          <Route path="web-service" element={<WebServicePage />} />
          <Route path="developers" element={<DevelopersPage />} />
          <Route
            path="developers/web-service"
            element={<DevelopersItemPage />}
          />
          <Route path="developers/plugin" element={<DevelopersItemPage />} />
          <Route
            path="developers/digi-extension"
            element={<DevelopersItemPage />}
          />
          <Route
            path="developers/php-package"
            element={<DevelopersItemPage />}
          />

          <Route path="*" element={<NotFound404 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
